import React from "react";
import { FetchAgentsItem } from "../../services/AgentServices/AgentTypes";

type Props = {
  agent: FetchAgentsItem;
  isSelected: boolean;
  onClick: () => void;
};

export default function AgentCard({ agent, isSelected, onClick }: Props) {
  return (
    <div
      onClick={onClick}
      className={`${
        isSelected ? "bg-black text-white" : "bg-white text-black"
      } cursor-pointer p-4 border-2 border-black mb-4 group`}
    >
      <div
        className={`flex flex-row space-x-2 font-Switzer font-semibold text-sm`}
      >
        {agent.agentRepresentations.map((t, i) => (
          <p>{t.representationTitle}</p>
        ))}
      </div>

      <p className={`font-Switzer font-semibold text-3xl pb-3`}>
        {agent.name ? agent.name : "N/A"}
      </p>
      <div
        className={`w-full grid grid-cols-auditionDetails text-base tracking-tight border-t-2 ${
          isSelected ? "border-white" : "border-black"
        } pt-3`}
      >
        <p className="font-bold">Location</p>
        <p>{agent.agentLocation ? agent.agentLocation.fullAddress : "N/A"}</p>
      </div>
    </div>
  );
}
